<template>
    <div class="show-all-view">
        <pane-header
            :tools="tools"
            :title="currentView.data.headerTitle"
            :subtitle="currentView.data.headerSub"
            :hasBackButton="true"
            :appIconKey="currentView.data.preset"
        />
        <ui-scrollable-container>
            <ui-data-list
                :preset="currentView.data.preset"
                type="full"
                :tools="tools"
                :itemCount="106"
            />
        </ui-scrollable-container>
    </div>
</template>

<script>
    export default {
        name: 'show-all-view',
        props: ['tools'],
        computed: {
            currentView() {
                return this.tools.currentView;
            },
        },
    };
</script>

<style>
    .show-all-view {
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// ShowAllView.vue?f4daa4dc